
import React from 'react';

export const BenefitsSection: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-user-star-line',
      title: 'Expertenbegleitung',
      description: 'Unser Expertenteam begleitet Sie individuell bei der Lösung Ihrer wichtigsten Herausforderungen.',
      image: 'https://public.readdy.ai/ai/img_res/1be760d55a12ccbb549a9a19b8254db8.jpg'
    },
    {
      icon: 'ri-question-answer-line',
      title: '24/7 Support',
      description: 'Wir stehen bei allen Fragen an Ihrer Seite und bieten kontinuierliche Unterstützung.',
      image: 'https://readdy.ai/api/search-image?query=Customer%20support%20team%20helping%20clients%2C%20professional%20help%20desk%2C%2024%2F7%20service%2C%20modern%20call%20center%2C%20friendly%20support%20staff%2C%20business%20assistance%2C%20professional%20customer%20service%20environment&width=400&height=300&seq=support-team&orientation=landscape'
    },
    {
      icon: 'ri-team-line',
      title: 'Unternehmer-Netzwerk',
      description: 'Auf Wunsch stehen Ihnen weitere Unternehmer zur Seite und teilen ihre Erfahrungen.',
      image: 'https://readdy.ai/api/search-image?query=Business%20networking%20event%2C%20entrepreneurs%20meeting%2C%20professional%20networking%2C%20business%20people%20discussing%2C%20collaborative%20environment%2C%20modern%20conference%20room%2C%20business%20partnership&width=400&height=300&seq=networking&orientation=landscape'
    },
    {
      icon: 'ri-time-line',
      title: 'Flexibles Tempo',
      description: 'Sie bestimmen selbst Ihr Tempo, so dass wir uns darauf anpassen werden, wieviel Zeit Sie zur Verfügung haben.',
      image: 'https://readdy.ai/api/search-image?query=Flexible%20work%20schedule%2C%20time%20management%2C%20business%20planning%2C%20calendar%20and%20clock%2C%20professional%20workspace%2C%20work-life%20balance%2C%20modern%20office%20with%20time%20planning%20tools&width=400&height=300&seq=flexible-time&orientation=landscape'
    }
  ];

  return (
    <section id="vorteile" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            So arbeiten wir zusammen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ihre Vorteile bei der Zusammenarbeit mit unserer Business Academy
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {benefits.map((benefit, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8`}>
              <div className="flex-1">
                <img 
                  src={benefit.image}
                  alt={benefit.title}
                  className="rounded-lg shadow-lg w-full h-64 object-cover object-top"
                />
              </div>
              
              <div className="flex-1">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                  <i className={`${benefit.icon} text-blue-600 text-2xl`}></i>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {benefit.title}
                </h3>
                
                <p className="text-gray-600 text-lg leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-50 rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Warum unsere Methode funktioniert
            </h3>
            <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto">
              Auf Basis unserer Erfahrung von über 35 Jahren und insgesamt mehr als 20.000 Kunden haben wir 
              die effektivsten Methoden ermittelt, die unsere Kunden einsetzen.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="text-3xl font-bold text-blue-600 mb-2">35+</div>
                <div className="text-gray-600">Jahre Erfahrung in der Digitalisierung</div>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="text-3xl font-bold text-green-600 mb-2">20.000+</div>
                <div className="text-gray-600">Erfolgreich begleitete Unternehmen</div>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-md">
                <div className="text-3xl font-bold text-purple-600 mb-2">100%</div>
                <div className="text-gray-600">Individuelle Betreuung garantiert</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
